/**
 * Build-time client links for Help's "More ways to get help" (they were the side support rail's).
 * Kept apart from the pages so jest (ts-jest CommonJS cannot parse `import.meta`) can mock it.
 */
export interface ClientLinks {
  /** VITE_CLIENT_TELEGRAM_SUPPORT_URL; empty when not set (the row is hidden). */
  telegramUrl: string;
  /** VITE_CLIENT_ANDROID_APK_URL; empty when not set (the row is hidden). */
  androidApkUrl: string;
}

export function getClientLinks(): ClientLinks {
  return {
    telegramUrl: String(import.meta.env.VITE_CLIENT_TELEGRAM_SUPPORT_URL || '').trim(),
    androidApkUrl: String(import.meta.env.VITE_CLIENT_ANDROID_APK_URL || '').trim(),
  };
}

/** URL of a file in `public/` under the app's base path. */
export function publicAssetUrl(file: string): string {
  return `${import.meta.env.BASE_URL}${file}`;
}
